import {
  CallStateMethodNames,
  CallStateMethods
} from '@shared/store-features/call-state-feature.ts';
import { CallStateEnum } from '@models/call-state.model.ts';
import { TableState } from '@store/table-store/table.model.ts';
import { SelectOption } from '@models/global.model.ts';

export type HandleClose = () => void;

export interface ProductsActionParams {
  data?: any;
  id?: number;
  state: TableState;
  handleClose?: HandleClose;
}

export interface ProductsState extends CallStateMethods {
  callState: CallStateEnum;
  category: SelectOption[];
  getInventoryCategories: () => void;
  createProduct: (params: ProductsActionParams) => void;
  editProduct: (params: ProductsActionParams) => void;
  deleteProduct: (params: ProductsActionParams) => void;
  togglePublish: (params: ProductsActionParams) => void;
}

interface ProductsStateMethods extends CallStateMethodNames {
  createProduct: 'createProduct';
  editProduct: 'editProduct';
  deleteProduct: 'deleteProduct';
  getInventoryCategories: 'getInventoryCategories';
  togglePublish: 'togglePublish';
}

export const PRODUCTS_INITIAL_STATE: Omit<
  ProductsState,
  keyof ProductsStateMethods
> = {
  category: [],
  callState: CallStateEnum.Init
};
